import { motion } from "framer-motion";

export default function MainBanner(props) {
  return (
    <div className="bg-black">
      <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
        <div>
          <span className="animate-pulse lg:text-[7vw] md:text-[10vw] font-light tracking-tight text-white">
            {props.firstTitle}
          </span>
          <h2
            className="text-[8vw] font-bold tracking-tight text-white sm:text-4xl "
            data-aos="fade-up"
          >
            About
          </h2>
          <div
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1000"
          >
            <h2 className="text-[8vw] italic font-bold tracking-tight text-white">
              {props.lastName}
            </h2>
            <h2 className="text-[8vw] mt-[-3vw] font-bold tracking-tight text-white">
              {props.firstName}
            </h2>
            <p className="mt-4 text-gray-500">{props.desc}</p>
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0.2 }}
          whileInView={{
            opacity: 1,
            rotate: [0, 30],
            borderRadius: ["20%", "50%"],
            transition: { delay: 0.05 },
          }}
          whileHover={{
            scale: 1.1,
            rotate: [0, 30],
            transition: { type: "spring", stiffness: 10, damping: 1 },
          }}
        >
          <img
            src={props.img}
            alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
            className="rounded-full"
          />
        </motion.div>
      </div>
    </div>
  );
}
